import Game from "../../src/shell/Game";
import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { emily } from "../characters/Emily";
import { emilyEx } from "../characters/EmilyEx";
import { mc } from "../characters/MC";
import { doImageShake, doTransition, doWaitImageByTime } from "../helpers/helpers";
import { V8EmilyKitchenNightAfter, setVanessaMCNightVariable } from "./V8";
import { images } from "./images";
const v8 = images.v8;
export const V8EmilyKitchenNight = async (): Promise<any> => {
    doTransition(v8.V8EmilyKitchenNight_0);

    let wordConditionForEx = '';
    // kitchen
    mc.think(`Emily...?`);
    doWaitImageByTime(v8.V8EmilyKitchenNight_1);
    if (Question.globalAnswers.v7InvitedEmilysEx === "invited") {
        mc.think(`Why is she just standing her by herself? Isn't her Ex still in her bedroom?`);
        wordConditionForEx = 'also ';
    }
    if (mc.properties.gotKissedByEmily) {
        mc.think(`I ${wordConditionForEx}haven't talked to her since that kiss...`);
        mc.think(`I'll just act normal like nothing has ever happened!`);
    }

    doWaitImageByTime(v8.V8EmilyKitchenNight_2);
    mc.talk(`Hey Emily.`);
    doWaitImageByTime(v8.V8EmilyKitchenNight_4);
    emily.talk(`Oh! ${mc.name}!`);
    mc.talk(`Sorry, I didn't mean to scare you.`);
    ImageClass.setImage(v8.V8EmilyKitchenNight_6);
    emily.talk(`It's fine, I just buried myself with thoughts...`);

    ImageClass.setImage(v8.V8EmilyKitchenNight_5);
    mc.talk(`Do you want to share?`);
    doWaitImageByTime(v8.V8EmilyKitchenNight_7);
    emily.talk(`It's not something we haven't talked about before...`);
    doWaitImageByTime(v8.V8EmilyKitchenNight_8);
    emily.talk(`I don't want to sound like a broken record.`);
    ImageClass.setImage(v8.V8EmilyKitchenNight_9);
    mc.talk(`You can talk to me, if it's going to help get some stuff out of your chest it's worth it.`);
    doWaitImageByTime(v8.V8EmilyKitchenNight_10);
    emily.talk(`I just feel like I have no direction in life.`);
    emily.talk(`Everything used to work so well for me and now I feel like a mess.`);
    ImageClass.setImage(v8.V8EmilyKitchenNight_9);
    mc.talk(`We all have those days.`);
    mc.talk(`It's all temporary, we all have our ups and down`);
    mc.talk(`Heck! You were the one who told me that when I was feeling down.`);
    doWaitImageByTime(v8.V8EmilyKitchenNight_7);
    emily.talk(`I know, I know.`);
    emily.talk(`Easier said that done, right?`);

    ImageClass.setImage(v8.V8EmilyKitchenNight_8);
    emily.talk(`I used to think the problem was me getting over my ex, but that's bullshit.`);
    if (Question.globalAnswers.v7InvitedEmilysEx === "invited") {
        ImageClass.setImage(v8.V8EmilyKitchenNight_10);
        emily.talk(`He is literally in my room and I just want him to go away.`);
        if (Question.globalAnswers.v8EmilyExKeepWatching) {
            mc.think(`That's weird... They just fucked not long ago.`);
        } else {
            mc.think(`That's weird... Didn't they make up not long ago?.`);
        }
        ImageClass.setImage(v8.V8EmilyKitchenNight_7);
        emily.talk(`I'm not angry that you let him in by the way... You couldn't just leave him outside.`);
        mc.think(`I guess she doesn't know I'm the one who invited him in the first place...`);
        mc.think(`I don't know what I was thinking... I thought it will help cheering her up a bit.`);
        mc.think(`I guess I didn't think this through.`);

        doWaitImageByTime(v8.V8EmilyKitchenNight_11);
        mc.talk(`Why do you want him gone?`);
        doWaitImageByTime(v8.V8EmilyKitchenNight_10);
        emily.talk(`I don't think we have a healthy relationship...`);
        emily.talk(`I feel like he has too much power over me.`);
        mc.talk(`I don't want to step beyond my boundaries but I had a small chat with him when he arrived...`);
        mc.talk(`I don't see how he gained so much power over you.`);
        mc.talk(`You are a strong woman, you always have been.`);

        ImageClass.setImage(v8.V8EmilyKitchenNight_7);
        emily.talk(`I don't know! It just happened!`);
        doWaitImageByTime(v8.V8EmilyKitchenNight_8);
        emily.talk(`That's why I want him gone.`);

    } else {
        ImageClass.setImage(v8.V8EmilyKitchenNight_11);
        mc.talk(`How did you come to this conclusion?`);
        ImageClass.setImage(v8.V8EmilyKitchenNight_12);
        emily.talk(`You learn a lot about yourself when you stare into the window at night... Haha.`);

    }
    ImageClass.setImage(v8.V8EmilyKitchenNight_11);
    mc.talk(`So what are your plans?`);
    ImageClass.setImage(v8.V8EmilyKitchenNight_12);
    emily.talk(`Right now? Is having a good night sleep and stop being a depressed mess!`);
    ImageClass.setImage(v8.V8EmilyKitchenNight_11);
    mc.talk(`Sounds like a great start.`);
    if (Question.globalAnswers.v7InvitedEmilysEx === "invited") {
        ImageClass.setImage(v8.V8EmilyKitchenNight_10);
        emily.talk(`But as you know... I have a big problem lying on my bed...`);
        mc.think(`I'm to blame for this mess... It's only fair that I'll help fixing it.`);
        return jump(V8EmilyKitchenNight_KickingExOut, "V8EmilyKitchenNight_KickingExOut");
    }


    return jump(V8EmilyKitchenNight_2, "V8EmilyKitchenNight_2");
};
export const V8EmilyKitchenNight_KickingExOut = async (): Promise<any> => {
    doWaitImageByTime(v8.V8EmilyKitchenNight_11);
    mc.talk(`Wait here.`);
    ImageClass.setImage(v8.V8EmilyKitchenNight_7);
    emily.talk(`${mc.name}? What are you planning?`);
    doWaitImageByTime(v8.V8EmilyKitchenNight_6);
    mc.talk(`Just wait, I got it.`);

    doTransition(v8.V8EmilyRoomNightAfterKitchen_0);
    // Emily's room.
    mc.talk(`Wakey wakey! Time to get up and get the fuck out.`);
    ImageClass.setImage(v8.V8EmilyRoomNightAfterKitchen_6);
    emilyEx.talk(`Woah! What's going on??? Where's Emily?`);
    mc.talk(`It's not your concern anymore.`);
    ImageClass.setImage(v8.V8EmilyRoomNightAfterKitchen_7);
    mc.talk(`You have one minutes to fuck off and that's me being generous.`);
    emilyEx.talk(`Where is Emily? Does she knows about what's going on?`);
    mc.talk(`What do you think?!`);
    ImageClass.setImage(v8.V8EmilyRoomNightAfterKitchen_6);
    mc.talk(`Now, should I say that again?`);
    emilyEx.talk(`No, no. I'll leave just relax.`);
    emilyEx.talk(`Just give me a second to get dressed.`);
    mc.talk(`You can get dressed outside.`);
    doWaitImageByTime(v8.V8EmilyRoomNightAfterKitchen_8);
    emilyEx.talk(`Wait! What about my clothes??? You can't leave me out like this!`);
    mc.talk(`Sorry, you are right.`);
    ImageClass.setImage(v8.V8EmilyRoomNightAfterKitchen_9);
    mc.talk(`Here, take this.`);
    ImageClass.setImage(v8.V8EmilyRoomNightAfterKitchen_10);
    mc.talk(`And don't try to talk to Emily ever again, she is done with you!`);
    doImageShake(v8.V8EmilyRoomNightAfterKitchen_11, { wait: 0.3, hideText: true });
    //Back in the kitchen
    doTransition(v8.V8EmilyKitchenNight_13);
    mc.talk(`All clear.`);
    emily.talk(`I can't believe you did that!`);
    mc.talk(`You said you wanted him out.`);
    emily.talk(`Yeah...`);
    emily.talk(`Haha, I can't believe you kicked him out naked.`);
    mc.talk(`Yeah... Fuck that guy!`);
    emily.talk(`You always know how to cheer me up.`);

    return jump(V8EmilyKitchenNight_2, "V8EmilyKitchenNight_2");
};

export const V8EmilyKitchenNight_2 = async (): Promise<any> => {
    doTransition(v8.V8EmilyRoomNightAfterKitchen_12);
    mc.talk(`So... Good night.`);

    emily.talk(`${mc.name}...?`);
    mc.talk(`Yes?`);
    emily.talk(`Can I ask something?`);
    mc.talk(`Of course.`);
    doWaitImageByTime(v8.V8EmilyRoomNightAfterKitchen_12.partials.V8EmilyRoomNightAfterKitchen_12_p);
    emily.talk(`Never mind! I had a change of heart.`);
    mc.talk(`What did you want to say? Tell me.`);
    emily.talk(`It's stupid...`);
    mc.talk(`...`);
    doWaitImageByTime(v8.V8EmilyRoomNightAfterKitchen_12);
    emily.talk(`I was thinking...`);
    emily.talk(`That maybe...`);
    // For people who saved the game after V8VanessaMCNight
    await setVanessaMCNightVariable();
    emily.talk(`You can keep me company...? until I fall asleep...`);

    doWaitImageByTime(v8.V8EmilyRoomNightAfterKitchen_12.partials.V8EmilyRoomNightAfterKitchen_12_p);
    await emily.setQuestion(new Question({ text: `That's a stupid thing to ask, forget it!`, options: { think: false }, key: `v8EmilyKitchenNightJoinHerBed` })
        .option({ title: `Join her`, key: true })
        .option({ title: `Refuse`, key: false }));


    if (Question.globalAnswers.v8EmilyKitchenNightJoinHerBed) {
        await mc.set((properties) => {
            properties.emilyRelationship += 5;
        });
        mc.talk(`Of course I'll keep you company.`);
        ImageClass.setImage(v8.V8EmilyRoomNightAfterKitchen_12.partials.V8EmilyRoomNightAfterKitchen_12_p_2);
        emily.talk(`Are you sure?`);
        if (mc.properties.v8VanessaVisitedAtNight) {
            emily.talk(`But... I over heard you have company...`);

            ImageClass.setImage(v8.V8EmilyRoomNightAfterKitchen_12.partials.V8EmilyRoomNightAfterKitchen_12_p_3);
            mc.talk(`She is fully asleep, she won't notice I'm gone.`);
            mc.talk(`Besides, you are more important.`);

            ImageClass.setImage(v8.V8EmilyRoomNightAfterKitchen_12.partials.V8EmilyRoomNightAfterKitchen_12_p_2);
            emily.talk(`You know that at one point you'll have to tell me what the heck is going on with you and all those girls.`);
            emily.talk(`And why Joey's girlfriend is sleeping in your bed.`);

            ImageClass.setImage(v8.V8EmilyRoomNightAfterKitchen_12.partials.V8EmilyRoomNightAfterKitchen_12_p_3);
            mc.talk(`I'll clear everything with time.`);
            ImageClass.setImage(v8.V8EmilyRoomNightAfterKitchen_12.partials.V8EmilyRoomNightAfterKitchen_12_p_2);
            emily.talk(`Thank you.`);
        } else {
            mc.talk(`Positive!`);
        }
        return jump(V8EmilyKitchenNight_EmilysRoom, "V8EmilyKitchenNight_EmilysRoom");

    } else {
        mc.talk(`I think it's healthier if we'll each go to it's room.`);
        ImageClass.setImage(v8.V8EmilyRoomNightAfterKitchen_12.partials.V8EmilyRoomNightAfterKitchen_12_p);
        emily.talk(`I completely agree! That was a stupid suggestion, that's why I said never mind.`);
        mc.talk(`No harm was done!`);
        emily.talk(`Good night ${mc.name}!`);
        return jump(V8EmilyKitchenNight_End, "V8EmilyKitchenNight_End");
    }

};
export const V8EmilyKitchenNight_EmilysRoom = async (): Promise<any> => {
    doWaitImageByTime(v8.V8EmilyRoomNightAfterKitchen_1);
    emily.talk(`${mc.name}? Where are you?`);
    doWaitImageByTime(v8.V8EmilyRoomNightAfterKitchen_2);
    emily.talk(`Come here.`);
    doWaitImageByTime(v8.V8EmilyRoomNightAfterKitchen_3);
    mc.think(`It's feeling nice to comfort Emily...`);
    doWaitImageByTime(v8.V8EmilyRoomNightAfterKitchen_4);
    mc.think(`...`);
    mc.think(`Fuck she got closer...`);
    doWaitImageByTime(v8.V8EmilyRoomNightAfterKitchen_5);
    mc.think(`Damn... She must be feeling my bulge...`);
    mc.think(`I just need to wait until she'll fall asleep.`);
    doTransition(v8.V8EmilyRoomNightAfterKitchen_4, {}, 2);
    mc.think(`She is breathing heavily...`);
    mc.think(`Time to get back to my room.`);


    return jump(V8EmilyKitchenNight_End, "V8EmilyKitchenNight_End");
};
export const V8EmilyKitchenNight_End = async (): Promise<any> => {

    return jump(V8EmilyKitchenNightAfter, "V8EmilyKitchenNightAfter");
};